<template>
  <div class="page-layout-date">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="10" :lg="13" :xl="15">
        <el-date-picker v-model="startDate" @change="getStartDate" type="date" placeholder="START">
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="6">
        <el-date-picker v-model="endDate" @change="getEndDate" type="date" placeholder="END">
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
        <el-button type="primary">EXCEL</el-button>
      </el-col>
    </el-row>
    <!-- <span class="start-date">

    </span>
    <span class="end-date">

    </span> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        startDate: new Date(),
        endDate: new Date(),
      };
    },
    methods: {
      getStartDate(val) {
        this.$emit('start-date', val)
      },
      getEndDate(val) {
        this.$emit('end-date', val)
      }
    },
    components: {}
  }

</script>

<style lang="scss">
  .page-layout-date {
    .start-date {}

    .end-date {}

  }

</style>
